import { Resource } from '@redge-media/fo-js-sdk';

export default {
  deserialize(response, opts = {}) {
    const data = Resource.prototype.deserialize.call(this, response, opts);
    return data.items;
  },
};
